React = require 'react'
ReactBacon = require 'react-bacon'
R = require 'ramda'
moment = require 'moment'
{Icon }= require 'react-fa'
PropTypes = require 'prop-types'
createReactClass = require 'create-react-class'

orderStore = require 'stores/order'
rdsOrderStore = require 'stores/rds-order'
ordersStore = require 'stores/orders'
userStore = require 'stores/user'

uiStore = require 'stores/ui'
{ Container, Col, Row, Button } = require 'reactstrap'
import PaymentsInfo from './v5/payments'
import { AuditResource } from '../../api/audit'

orderUtils = require './components/utils'

{ toID, shortID, touple, booleanOf, currency, percent } = orderUtils
{ formatTimeWithOffset, pairsToTable, pairsToList, googleMapsLinkToAddress } = orderUtils
{ UserIs, UserIsNot, UserWants } = orderUtils

OrderInfo               = require './sections/info'
CustomerInfo            = require './sections/customer'
RestaurantInfo          = require './sections/restaurant'
OrderItems              = require './sections/items'
OrderEvents             = require './sections/events'
RestaurantNotifications = require './sections/notifications'
OrderTotal              = require './sections/total'
OrderHeading            = require './sections/heading'
DeliveryInfo            = require './sections/delivery'

OrderToolbar            = require './toolbar'

OrderTab = createReactClass
  displayName: 'OrderTab'
  mixins: [ReactBacon.BaconMixin, require('./loader')]

  componentWillMount: ->
    uiStore.setCurrentUI("orders", "orderId")

  render: ->
    if !@state.order or !@state.restaurant
      return @renderLoadingWithErrors()

    if @state.order
      <Container fluid={true} style={paddingLeft: "0px", paddingRight: "0px"} key={@state.order.id}>
        { @renderToolbarRow(@state.order, @state.rdsOrder) }
        { @renderContentRow(@state.order, @getLocale()) }
      </Container>
    else
      null

  onRemoveTab: ->
    ordersStore.unpin @state.order.id
    uiStore.switchToFirst()

  renderToolbarRow: (order, rdsOrder) ->
    # usesPayments2 = !(@props.paymentsQuery.loading && @props.paymentsQuery.data && @props.paymentsQuery.data.order != null)
    usesPayments2 = R.path(['paymentsQuery', 'data', 'order'], @props) != null

    <Row key="toobar">
      <Col sm={12}>
        <OrderToolbar key={@state.order.id} model={orderStore} order={order} rdsOrder={rdsOrder} actions={@state.actions} notifications={@state.notifications} restaurant={@state.restaurant} usesPayments2={usesPayments2}>
          <Button onClick={@onRemoveTab}> <Icon fixedWidth name="remove"/> </Button>
        </OrderToolbar>
      </Col>
    </Row>

  renderContentRow: (order, locale) ->
    state = if @state.orderState then @state.orderState.state else "n/a"
    # usesPayments2 = !(@props.paymentsQuery.loading && @props.paymentsQuery.data && @props.paymentsQuery.data.order != null)
    usesPayments2 = R.path(['paymentsQuery', 'data', 'order'], @props) != null

    <Row key="content" key={order.id}>
      <Col xs={12} sm={12} key={@state.order.id}>
        {@_renderError()}
        <OrderHeading order={@state.order} gqlOrder={@props.order} rdsOrder={@state.rdsOrder} restaurant={@state.restaurant} state={state} locale={locale}/>
      </Col>
      <Col xs={12} sm={12} md={6} lg={4}>
        <OrderInfo key="order_info_#{@state.order.id}" gqlOrder={@props.order} order={@state.order} locale={locale} restaurant={@state.restaurant} events={@state.events} />
        <RestaurantInfo key={@state.restaurant.permalink} restaurant={@state.restaurant} channel={@state.channel} order={@state.order} />
      </Col>
      <Col xs={12} sm={12} md={6} lg={4}>
        {
          if @state.rdsOrder
            <UserIs role="dispatcher">
              <DeliveryInfo order={@state.rdsOrder} locale={locale} restaurant={@state.restaurant}/>
            </UserIs>
        }
        <OrderItems order={@state.order} locale={locale} restaurant={@state.restaurant} />
      </Col>
      <Col xs={12} sm={12} md={6} lg={4}>
        <RestaurantNotifications order={@state.order} locale={locale} restaurant={@state.restaurant} notifications={@state.notifications}/>
        <OrderTotal order={@state.order} locale={locale} restaurant={@state.restaurant} />
      </Col>
      <Col xs={12} sm={12} style={overflowWrap: 'anywhere'}>
        { if usesPayments2
            <AuditResource resourceType="order" resourceId={@state.order.id}>
              <PaymentsInfo
                orderId={@state.order.id} 
                data={@state.order} 
                order={@props.paymentsQuery.data.order}
                reload={() => @props.paymentsQuery.refetch({ order_id: @state.order.id }) } 
                skipAdjustments={false} /> 
            </AuditResource>
          else 
            <span></span>
        }
      </Col>
      <Col xs={12} sm={12} style={overflowWrap: 'anywhere'}>
        { if userStore.hasAnyRole('config', 'restaurant_admin', 'restaurant', 'restaurant_staff')
            <UserWants name="show-order-events">
              <OrderEvents order={@state.order} locale={locale} restaurant={@state.restaurant} events={@state.events}/>
            </UserWants>
          else
            <></>
        }
      </Col>
      
    </Row>

module.exports = OrderTab
